<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">I would like to dedicate this novel to my beautiful grandmother, Betrice Kasha. I will always love and miss you. And to my wonderful husband, who has stuck with and put up with me through it all.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?3745b906